import { Component, OnInit } from "@angular/core";
import { TrustService } from "@fiduciaria/Shared/Services/trust.service";
import { TrustRequest } from "@fiduciaria/Shared/Types/request.interface";
import { Observable, shareReplay } from "rxjs";

import { Usuario } from "@shared/Entities/Usuario/usuario.entity";
import { UsuariosRepository } from "@shared/Repositories/usuarios.repository";

import { TrustRequestsFilter } from "../Shared/Types/requests-filter.interface";

import { FiduciaryStep } from "./Types/Enums/fiduciary-step.enum";

@Component({
  selector: "app-fiduciary-request-search",
  templateUrl: "./fiduciary-request-search.component.html",
})
export class FiduciaryRequestSearchComponent implements OnInit {
  public readonly FiduciaryStep = FiduciaryStep;
  public selectedRequest: TrustRequest;
  public currentStep = FiduciaryStep.Form;
  public trustRequests$: Observable<TrustRequest[]>;
  private currentUsuario: Usuario;
  public isUserFidiciary: boolean;
  public currentRequestFilter: TrustRequestsFilter;

  private readonly rolesPermitidos = ["Canales Fiduciaria", "Administrador Corporativo Fiduciaria", "Operativo Fiduciaria"];

  constructor(private readonly trustService: TrustService, private readonly userRepository: UsuariosRepository) {}

  public ngOnInit(): void {
    this.userRepository.getInfoClienteActual().subscribe((usuario) => {
      this.currentUsuario = usuario;
      this.isUserFidiciary = usuario.usuarioRole.some((x) => this.rolesPermitidos.includes(x.role.nombre));
    });
  }

  public onSubmitSearchForm(requestfilter: TrustRequestsFilter): void {
    this.currentStep = FiduciaryStep.Result;
    this.currentRequestFilter = requestfilter;

    if (this.isUserFidiciary) {
      requestfilter.codigoUsuario = this.currentUsuario.userFbaId;
      this.trustRequests$ = this.trustService.getTrustApplicationsByUserEscrowsRequests(requestfilter).pipe(shareReplay(1));
    } else {
      this.trustRequests$ = this.trustService.getTrustRequests(requestfilter).pipe(shareReplay(1));
    }
  }

  public sendSearchForm(requestfilter: TrustRequestsFilter): void {
    this.currentStep = FiduciaryStep.Result;
    this.currentRequestFilter = requestfilter;

    if (this.isUserFidiciary) {
      requestfilter.codigoUsuario = this.currentUsuario.userFbaId;
      this.trustRequests$ = this.trustService.getTrustApplicationsByUserEscrowsRequests(requestfilter).pipe(shareReplay(1));
    } else {
      this.trustRequests$ = this.trustService.getTrustRequestsAlways(requestfilter).pipe(shareReplay(1));
    }
  }

  public onSeeDetails(request: TrustRequest): void {
    this.selectedRequest = request;
    this.currentStep = FiduciaryStep.Details;
  }

  public backStep(): void {
    this.currentStep -= 1;
  }
}
